
export default {
  name: 'plaintes',
  components: {},
  props: [],
  data () {
    return {
      plaintes: {
        libelle: "",
        consultation_id: 0
     },
      save_loading: false

    }
  },
  computed: {
    consultationEnCours() {
      return this.$store.getters['consultationPatientEnCours']
    },

  },
  mounted () {
    this.plaintes.libelle = this.consultationEnCours.plaintes 
  },
  methods: {
    savePlaintes(){
      this.$refs.form.validate().then((success) => {

        if (!success) {
            return;
        }

        this.save_loading = true;
        /* this.hypothese.consultation_id = this.consultation */
        /* console.log('hypothese', this.hypothese); */

        this.$store.dispatch("savePlaintes", {id:this.consultationEnCours.id,data:this.plaintes}).then((response) => {
            console.log('response', response)
            this.doSuccessMsg('Les plaintes sont enregistrées avec succès !')
            this.save_loading = false;

        })
    });
    },
    doSuccessMsg: function(msg) {
      this.$toasted.show(msg, {
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          position: 'top-center',
          duration: 5000,
          theme: 'toasted-primary',
          type: 'success'
      })
  },
  doErrorMsg: function(msg) {
      this.$toasted.show(msg, {
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          position: 'top-center',
          duration: 5000,
          theme: 'toasted-primary',
          type: 'error'
      })
  },

  }
}


